import { ProductFeedbackQuestionIds } from '@/constants';
import { ProductFeedbackQuestion, ProductFeedbackQuestionId } from '@/types';

export type ProductFeedbackForm = Record<
  ProductFeedbackQuestionId,
  string | boolean | undefined
>;

export const FeedbackSentiment = {
  VeryDisappointed: 'Very Disappointed',
  SomewhatDisappointed: 'Somewhat Disappointed',
  NotDisappointed: 'Not Disappointed',
};

export const Questions: Record<
  ProductFeedbackQuestionId,
  ProductFeedbackQuestion
> = {
  [ProductFeedbackQuestionIds.sentiment]: {
    questionId: ProductFeedbackQuestionIds.sentiment,
    question: 'How would you feel if you could no longer use LumiQ?',
    options: [
      FeedbackSentiment.VeryDisappointed,
      FeedbackSentiment.SomewhatDisappointed,
      FeedbackSentiment.NotDisappointed,
    ],
  },
  [ProductFeedbackQuestionIds.isRecommended]: {
    questionId: ProductFeedbackQuestionIds.isRecommended,
    question: 'Have you ever recommended LumiQ to anyone?',
  },
  [ProductFeedbackQuestionIds.recommendReason]: {
    questionId: ProductFeedbackQuestionIds.recommendReason,
    question: 'When you recommended LumiQ, how did you describe it?',
  },
  [ProductFeedbackQuestionIds.suggestions]: {
    questionId: ProductFeedbackQuestionIds.suggestions,
    question: 'How can we improve LumiQ to better meet your needs?',
  },
  [ProductFeedbackQuestionIds.followUpEmail]: {
    questionId: ProductFeedbackQuestionIds.followUpEmail,
    question:
      'We read all responses and take them to heart. Sometimes we even reach out to get more details. Can we contact you about your feedback?',
  },
};

export const FEEDBACK_WIDGET_STEP = 'feedbackWidget';

export const Steps = [
  ProductFeedbackQuestionIds.sentiment,
  ProductFeedbackQuestionIds.isRecommended,
  ProductFeedbackQuestionIds.suggestions,
  ProductFeedbackQuestionIds.followUpEmail,
] as const;
